import React, { useState } from 'react'

/**
 * ImageGallery Component
 * 
 * Displays a grid of images with lightbox viewer
 * 
 * Props:
 * - images: Array of image objects { image_url, caption, is_primary }
 * - onDelete: Optional callback for delete action (if user owns)
 */
function ImageGallery({ images = [], onDelete }) {
  const [lightboxOpen, setLightboxOpen] = useState(false)
  const [currentImageIndex, setCurrentImageIndex] = useState(0)

  if (!images || images.length === 0) {
    return (
      <div className="no-images-message">
        <p>📷 No images yet</p>
      </div>
    )
  }

  const openLightbox = (index) => {
    setCurrentImageIndex(index)
    setLightboxOpen(true)
  }

  const closeLightbox = () => {
    setLightboxOpen(false)
  }

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % images.length)
  }

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length)
  }

  return (
    <>
      <div className="image-gallery-grid">
        {images.map((img, index) => (
          <div 
            key={img.image_id || index} 
            className="gallery-image-card"
            onClick={() => openLightbox(index)}
          >
            <img src={img.image_url} alt={img.caption || `Image ${index + 1}`} />
            
            {img.is_primary && (
              <div className="primary-badge">⭐ Primary</div>
            )}

            {img.caption && (
              <div className="image-caption-overlay">{img.caption}</div>
            )}

            {onDelete && (
              <button
                className="btn-delete-image"
                onClick={(e) => {
                  e.stopPropagation()
                  onDelete(img.image_id)
                }}
                title="Delete image"
              >
                🗑️
              </button>
            )}
          </div>
        ))}
      </div>

      {/* Lightbox Modal */}
      {lightboxOpen && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <button className="lightbox-close" onClick={closeLightbox}>✕</button>
          
          <button className="lightbox-prev" onClick={(e) => { e.stopPropagation(); prevImage(); }}>
            ‹
          </button>

          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img 
              src={images[currentImageIndex].image_url} 
              alt={images[currentImageIndex].caption || 'Full size'} 
            />
            
            {images[currentImageIndex].caption && (
              <p className="lightbox-caption">{images[currentImageIndex].caption}</p>
            )}

            <div className="lightbox-counter">
              {currentImageIndex + 1} / {images.length}
            </div>
          </div>

          <button className="lightbox-next" onClick={(e) => { e.stopPropagation(); nextImage(); }}>
            ›
          </button>
        </div>
      )}
    </>
  )
}

export default ImageGallery